export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/fbf1cfaf74329f9a6a1fed67972e7c52.svg";